import ArrayHandler from '../handlers/ArrayHandler';

abstract class Enumeration {

	public constructor (private value: string) {
		this.assertValidValue(value);
	}

	public is (value: string) {
		return this.value === value;
	}

	public getValue () {
		return this.value;
	}

	protected abstract getPossibleValues (): string[];

	private assertValidValue (value: string) {
		if (!ArrayHandler.includes(this.getPossibleValues(), value)) {
			throw new Error('Invalid enumeration choice');
		}
	}
}

export default Enumeration;


// WEBPACK FOOTER //
// ./code/foundation/enumeration/Enumeration.ts